
/**
* Component     : Routing
* Author        : Boston Byte LLC
* Creation Date : 22nd May 2018
*/


import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { TranslatorService } from '../core/translator/translator.service';
import { MenuService } from '../core/menu/menu.service';
import { menu } from './menu';
import { routes } from './routes';
import { SessionService } from '@app/common';
import { ARCHIVE_MENU_CONFIG, COOKIES_CONSTANTS } from '@app/config';



@NgModule({
    imports: [
        RouterModule.forRoot(routes)
    ],
    declarations: [],
    exports: [
        RouterModule,
    ]
})

export class RoutesModule {
    constructor(public menuService: MenuService, tr: TranslatorService,
        public sessionService:SessionService) {
        let ArcMode=this.sessionService.getCookie(COOKIES_CONSTANTS.archiveMode)
        if(ArcMode=="ENABLED"){
            menuService.addMenu(ARCHIVE_MENU_CONFIG);
        }else{
            menuService.addMenu(menu);
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/routes/routes.module.ts